export const it = {
    consent: {
        titulo: "Consenso ai cookie",
        texto: "Utilizziamo i cookie per misurare le visite e migliorare la comunicazione dell'evento. La misurazione di marketing è attivata solo con il tuo consenso.",
        aceitar: "Accetta",
        rejeitar: "Solo essenziali",
        saberMais: "Scopri di più",
    },
    nav: {
        experiencia: "Esperienza",
        noiteFados: "Notte di Fado",
        equipa: "Team",
        artistas: "Artisti",
        noticias: "Notizie",
        missao: "Missione",
        associacao: "L'Associazione",
        vantagens: "Vantaggi Soci",
        contacto: "Contatti",
        reservar: "Prenota",
        local: "Come Arrivare",
    },
    hero: {
        headlineTop: "UNA SERATA\nDEDICATA AL",
        headlineAdj: "PORTOGHESE",
        headlineItalico: "Una serata portoghese.\nA tavola.\nDal vivo.",
        quando: "Quando",
        data: "14 Novembre 2026",
        hora: "dalle 17:00",
        onde: "Dove",
        local: "Centro Papa Giovanni",
        morada: "Hübelistrasse 55, Emmenbrücke",
        comprar: "Acquista Biglietti",
        urgencia: "Evento esclusivo · Posti limitati",
        saibaMais: "Scopri di più",
        countdown: {
            label: "Il prezzo Early Bird termina tra",
            dias: "giorni",
            horas: "ore",
            min: "min",
            seg: "sec",
        },
    },
    pillars: [
        { id: "fado-ao-vivo", title: "Fado dal Vivo", text: "L'emozione del Fado, patrimonio immateriale del Portogallo." },
        { id: "gastronomia", title: "Gastronomia Portoghese", text: "Sapori tradizionali in una cena preparata con eccellenza." },
        { id: "vinhos", title: "Vini Portoghesi", text: "Una selezione di vini dalle migliori regioni del Portogallo." },
        { id: "cultura", title: "Cultura e Tradizione", text: "Una celebrazione della nostra identità, storia e ospitalità." },
        { id: "ambiente", title: "Atmosfera Esclusiva", text: "Uno spazio intimo per un'esperienza indimenticabile." },
    ],
    watermark: "Esempio Visivo",
    influencer: {
        label: "Influencer Ufficiale",
        nome: "Nelson Jackson",
        titulo: "La voce che porta Fados à Mesa alla comunità",
        texto: "Nelson Jackson è l'influencer ufficiale di Fados à Mesa. Con la bandiera sulle spalle e la sua energia di sempre, ci accompagnerà nel conto alla rovescia verso la serata del 14 novembre — dietro le quinte, novità e sorprese sui social.",
        legenda: "Il messaggio di Nelson Jackson alla comunità portoghese",
        play: "Guarda il video",
    },
    convidadoHonra: {
        label: "Ospite d'Onore",
        confirmado: "Partecipazione confermata",
        bemVindo: "Benvenuto, Eccellenza!",
        excelencia: "Sua Eccellenza",
        nome: "Dr. Gonçalo Motta",
        cargo: "Console Generale del Portogallo a Zurigo",
        citacao: "La cultura ci avvicina. Il Portogallo vive in ognuno di noi.",
        texto: "È con grande onore che accogliamo Sua Eccellenza il Dr. Gonçalo Motta, Console Generale del Portogallo a Zurigo, come nostro ospite d'onore a Fados à Mesa. La presenza della rappresentanza diplomatica del Portogallo è un riconoscimento del valore della cultura portoghese e dell'importanza di mantenere vive le nostre tradizioni, unendo la comunità attorno alla musica, alla gastronomia e alla nostra identità.",
        sobreTitulo: "Chi è il Dr. Gonçalo Motta",
        sobre: "Il Dr. Gonçalo Motta è l'attuale Console Generale del Portogallo a Zurigo, in rappresentanza del Ministero degli Affari Esteri portoghese. Formatosi all'Universidade Lusíada di Lisbona e con una vasta esperienza diplomatica, si dedica al rafforzamento delle relazioni tra Portogallo e Svizzera, al sostegno delle comunità portoghesi e alla promozione della cultura e dell'immagine del Portogallo all'estero.",
        verCartaz: "Vedi il manifesto ufficiale",
    },
    patrocinadores: {
        titulo: "SPONSOR UFFICIALI",
        maisA: "E altri",
        maisB: "Sponsor",
        agradecimentos: {
            famosa: "La nostra profonda gratitudine alla Pastelaria Famosa, Sponsor Esclusiva, per la fiducia e la dolcezza con cui accompagna questa serata fin dal primo giorno.",
            srVinho: "Grazie a Sr. Vinho, ristorante tipico che accoglie i nostri soci con il 10% di sconto e un digestivo in omaggio.",
            cr7Helder: "Il nostro sincero ringraziamento a CR7 Helder, per aver creduto nel Fado e per condurci, con eleganza, fino a questa serata.",
            saboresPortugal: "Il nostro sincero ringraziamento a Sabores de Portugal, per portare in tavola il meglio della nostra gastronomia e dare a questa serata un autentico sapore di Portogallo.",
            wildenMann: "Grazie all'Hotel Wilden Mann, cinque secoli di ospitalità lucernese al fianco del Fado.",
            barniPost: "Grazie al Barni-Post, che porta il Fado in ogni casa della Svizzera centrale.",
            superBock: "Grazie al Super Bock Group, che porta in tavola la più portoghese delle birre.",
            clubPortugues: "Grazie al Club Português Luzern, casa della nostra comunità da tanti anni.",
            casaBenfica: "Grazie alla Casa Benfica Zurique, per la passione che unisce i portoghesi di tutta la Svizzera.",
            immoHaus: "Grazie a ImmoHaus Portugal, che aiuta tante famiglie a trovare casa — e a noi apre la sua.",
        },
    },
    artistas: { titulo: "I NOSTRI ARTISTI" },
    parceiros: { titulo: "PARTNER ISTITUZIONALI" },
    localizacao: {
        saberMais: "Scopri di più",
        label: "Dove si svolge l'evento",
        titulo: "COME ARRIVARE",
        intro: "L'evento si svolge a Emmenbrücke, raggiungibile con i mezzi pubblici, in auto o in bicicletta. Di seguito le informazioni pratiche per arrivare.",
        moradaLabel: "Indirizzo",
        moradaValor: "Centro Papa Giovanni, Hübelistrasse 55, 6020 Emmenbrücke, Svizzera",
        gpsLabel: "Coordinate GPS",
        gpsValor: "47.0706° N, 8.2849° E",
        acessosTitulo: "Accessi",
        transportesTitulo: "Trasporto Pubblico",
        transportes: "Stazione Emmenbrücke Gersag a circa 10 minuti a piedi (treni regionali e bus 41, 42, 43 e 44). Da Lucerna, linea VBL 2; al ritorno, bus notturno N2.",
        carroTitulo: "Auto",
        carro: "A 5 minuti dall'autostrada A2 (uscita Emmen Nord).",
        bicicletaTitulo: "Bicicletta",
        bicicleta: "Parcheggio per biciclette disponibile in loco.",
        estacionamentoTitulo: "Parcheggio Gratuito",
        estacionamento: "Parcheggio Häger gratuito proprio di fronte — solo i posti segnalati «Häger», salvo disponibilità. Altri parcheggi nelle vicinanze, gratuiti e a pagamento.",
        regrasTitulo: "Regole del Centro Papa Giovanni",
        regras: [
            "Vietato l'ingresso e la permanenza di animali domestici.",
            "Vietato fumare in tutta l'area interna dell'edificio.",
        ],
    },
    cta: {
        comprar: "Acquista Biglietti",
        urgencia: "Evento esclusivo · Posti limitati",
        titulo: "PRENOTA ORA IL TUO POSTO.",
        subtitulo: "Una serata. Una tavola. Un Fado.",
    },
    culturaNoticias: {
        noticias: "ULTIME NOTIZIE",
        nota: "Notizie di esempio — le novità sull'evento appariranno qui.",
        news: [
            { title: "Fados à Mesa lancia la prima edizione il 14 novembre 2026", date: "15 MAG 2025" },
            { title: "Scopri gli artisti che danno vita al Fado sul palco", date: "10 MAG 2025" },
            { title: "Sapori del Portogallo: la cena che celebra la nostra tradizione", date: "05 MAG 2025" },
        ],
    },
    footer: {
        frase: "Una notte Portoghese, con assoluta certezza.",
        copyright: "© 2026 Fados à Mesa – Tutti i diritti riservati.",
        sede: "Associazione Fados à Mesa · UID CHE-306.330.271 · Gerliswilstrasse 46, 6020 Emmenbrücke, Svizzera",
        privacy: "Informativa sulla Privacy",
        terms: "Termini e Condizioni",
        colunas: [
            {
                title: "Notte di Fado",
                links: [
                    { label: "Menu della Serata", to: "/experiencia?tab=menu" },
                    { label: "Cultura e Tradizione", to: "/experiencia?tab=cultura" },
                    { label: "Gastronomia e Vini", to: "/experiencia?tab=gastro" },
                    { label: "Bar", to: "/experiencia?tab=bar" },
                    { label: "Team", to: "/equipa", ate1aEdicao: true },
                ],
            },
            {
                title: "Artisti",
                links: [
                    { label: "Artisti", to: "/#artistas" },
                    { label: "Notizie", to: "/noticias" },
                ],
            },
            {
                title: "L'Associazione",
                links: [
                    { label: "Missione", to: "/missao" },
                    { label: "Vantaggi Soci", to: "/socios/vantagens" },
                    { label: "Diventa Socio", to: "/associacao#adesao" },
                    { label: "Sponsor", to: "/patrocinadores" },
                ],
            },
            {
                title: "Biglietti",
                links: [
                    { label: "Acquista Biglietti", to: "/bilhetes" },
                    { label: "Conferma Presenza", to: "/confirmar" },
                ],
            },
            {
                title: "Contatti",
                links: [
                    { label: "Contattaci", to: "/contacto" },
                    { label: "Come Arrivare", to: "/local" },
                    { label: "Centro Risorse", to: "/recursos" },
                ],
            },
        ],
    },
    subpage: { voltar: "Indietro" },
    audio: { tocar: "Riproduci la musica", pausar: "Metti in pausa la musica" },
    bc: {
        home: "Pagina iniziale",
        experiencia: "Esperienza",
        equipa: "Team",
        artistas: "Artisti",
        noticias: "Notizie",
        missao: "Missione",
        contacto: "Contatti",
        local: "Location",
        confirmar: "Conferma",
        bilhetes: "Biglietteria",
        privacidade: "Informativa sulla Privacy",
        termos: "Termini e Condizioni",
        recursos: "Centro Risorse",
        patrocinadores: "Sponsor",
    },
    seo: {
        keywords: "Fado, Fados à Mesa, cultura portoghese, gastronomia portoghese, vini portoghesi, evento portoghese Svizzera, Fado Lucerna, Emmenbrücke, cena spettacolo, Ticket Corner",
        home: { title: "Fados à Mesa — Fado, Gastronomia e Vini portoghesi in Svizzera", desc: "Cena-spettacolo con Fado dal vivo, gastronomia e vini portoghesi. 14 novembre 2026, Centro Papa Giovanni, Emmenbrücke. Prenota il tuo biglietto." },
        experiencia: { title: "L'Esperienza — Menu, Line-up ed Etichetta del Fado | Fados à Mesa", desc: "Scopri il menu ufficiale, il line-up della serata e l'etichetta del Fado: una serata portoghese servita a tavola, tra piatti tradizionali e fado dal vivo." },
        equipa: { title: "Il Nostro Team — Produzione e Staff | Fados à Mesa", desc: "Scopri il team che rende possibile la serata: produzione esecutiva e artistica, cucina e sala della 1ª edizione di Fados à Mesa." },
        missao: { title: "La Missione — Cultura Portoghese in Svizzera | Fados à Mesa", desc: "Portare la cultura portoghese in Svizzera — una serata, una tavola e una chitarra alla volta. Cultura, tavola e incontro: i valori di Fados à Mesa." },
        contacto: { title: "Contatti — Scrivici | Fados à Mesa", desc: "Contatti dell'evento Fados à Mesa: prenotazioni di gruppo, partnership e sponsorizzazioni, stampa e domande sulla 1ª edizione." },
        local: { title: "Come Arrivare — Centro Papa Giovanni, Emmenbrücke | Fados à Mesa", desc: "Come raggiungere il Centro Papa Giovanni (Hübelistrasse 55, Emmenbrücke): trasporti pubblici, auto, Uber e bicicletta. Parcheggio gratuito." },
        noticias: { title: "Notizie — Fado, Cultura Portoghese e Novità | Fados à Mesa", desc: "Annunci ufficiali di Fados à Mesa e notizie selezionate sui nostri artisti: Rafael Pacheco, Ginestal Martins, Cátia Garcia, Daniel Pinto Coelho e Madalena Gil." },
        confirmar: { title: "Conferma la tua Presenza — Scegli il Piatto | Fados à Mesa", desc: "Conferma la tua presenza a Fados à Mesa e scegli il piatto principale (pesce o carne) entro il 1º novembre 2026." },
        bilhetes: { title: "Biglietteria Ufficiale — Acquista Biglietti | Fados à Mesa", desc: "Acquista il tuo biglietto per Fados à Mesa nella biglietteria ufficiale (Eventim / Ticket Corner). Evento esclusivo, posti limitati. 14.11.2026, Emmenbrücke." },
        privacidade: { title: "Informativa sulla Privacy | Fados à Mesa", desc: "Informativa sulla privacy di Fados à Mesa — trattamento dei dati personali secondo la legge svizzera (nLPD)." },
        associacao: { title: "L'Associazione | Fados à Mesa", desc: "L'Associazione Fados à Mesa: chi siamo, dati istituzionali, direzione, partner, quote, domanda di adesione e statuto." },
        termos: { title: "Termini e Condizioni | Fados à Mesa", desc: "Termini e condizioni del sito e dell'evento Fados à Mesa." },
        recursos: { title: "Centro Risorse — Stampa e Partner | Fados à Mesa", desc: "Materiali ufficiali di Fados à Mesa per stampa e partner: project book, press kit, loghi e programma della serata." },
        patrocinadores: { title: "Sponsor Ufficiali | Fados à Mesa", desc: "I partner ufficiali di Fados à Mesa — una serata portoghese in Svizzera." },
    },
    assoc: {
        titulo: "L'ASSOCIAZIONE",
        intro: "Un'associazione senza scopo di lucro, politicamente neutrale e confessionalemente indipendente, costituita a Emmen il 25 settembre 2026.",
        subnav: { quemSomos: "Chi siamo", dados: "Dati", direcao: "Direzione", parceiros: "Partner", quotas: "Quote", adesao: "Adesione", estatutos: "Statuto" },
        quemSomos: {
            titulo: "CHI SIAMO",
            p1: "L'Associazione Fados à Mesa è un'associazione senza scopo di lucro, politicamente neutrale e confessionalemente indipendente, con sede a Emmen, nel Canton Lucerna. Ha lo scopo di promuovere, preservare e divulgare la cultura portoghese e lusofona in Svizzera, in particolare il fado, la musica, la gastronomia, la lingua e le tradizioni portoghesi.",
            p2: "Per questo organizziamo eventi culturali, musicali, gastronomici, educativi e sociali; il nostro progetto principale è l'evento «Fados à Mesa». Promuoviamo lo scambio culturale tra la comunità lusofona e la popolazione svizzera, sosteniamo artisti e creatori di espressione portoghese e cooperiamo con comuni, cantoni, fondazioni, imprese, istituzioni culturali e altre associazioni.",
            p3: "Le nostre attività sono aperte al pubblico in generale. L'associazione non persegue scopi di lucro: eventuali eccedenze sono integralmente destinate agli scopi statutari e non vengono mai distribuite ai membri.",
        },
        dados: {
            titulo: "DATI ISTITUZIONALI",
            denominacao: "Denominazione", formaJuridica: "Forma giuridica", sede: "Sede", morada: "Indirizzo",
            constituicao: "Data di costituzione", duracao: "Durata", uid: "Numero UID", conta: "Conto bancario",
            exercicio: "Esercizio sociale", contacto: "Contatto",
            denominacaoV: "Associação Fados à Mesa (Verein Fados à Mesa)",
            formaJuridicaV: "Associazione senza scopo di lucro, art. 60 e segg. CC",
            sedeV: "Comune di Emmen, Canton Lucerna, Svizzera",
            moradaV: "Gerliswilstrasse 46, 6020 Emmenbrücke",
            constituicaoV: "25.09.2026 (Assemblea di fondazione, verbale n. 1)",
            duracaoV: "Tempo indeterminato",
            emTratamento: "In corso", aDesignar: "Da designare",
            exercicioV: "Anno civile",
        },
        direcao: {
            titulo: "DIREZIONE E MEMBRI FONDATORI",
            comite: "Comitato Esecutivo", mandato: "Mandato 2026–2028",
            fundadores: "Membri fondatori con funzioni nei giorni degli eventi",
            nota: "La Presidente, la Vicepresidente, la Direttrice della Logistica e il Direttore Tecnico sono i quattro membri fondatori dell'associazione.",
            paulaAngelinoNota: "Assume inoltre la direzione artistica, il marketing, il design e la comunicazione.",
            cristinaNota: "Assume tutti i poteri esecutivi in caso di impedimento della Presidente.",
            paulaSilvaNota: "Gestione della logistica e dei team nei giorni degli eventi.",
            pauloNota: "Coordinamento tecnico degli eventi.",
            cargoPaulaAngelino: "Presidente e Direttrice Esecutiva",
            cargoCristina: "Vicepresidente",
            cargoPaulaSilva: "Membro fondatore e Direttrice della Logistica",
            cargoPaulo: "Membro fondatore e Direttore Tecnico",
        },
        parceiros: {
            titulo: "PARTNER E SPONSOR",
            intro: "Istituzioni e partner che si sono uniti a noi per dare voce alla cultura portoghese in Svizzera. La cultura si costruisce anche in partnership.",
            institucional: "Partner istituzionale",
            patrocinadores: "Sponsor",
            parceiroInstitucional: "Partner istituzionale",
            celimar: "Partner esclusivo per consulenza e assicurazioni",
            ptPrint: "Tipografia Partner",
            barniPost: "Media Partner · Edizione del 21 ottobre 2026",
            tiers: { exclusiva: "Sponsor Esclusiva", oficial: "Partner Ufficiale", premium: "Sponsor Premium Ufficiale", intermediario: "Co-sponsor", apoiante: "Sostenitore" },
            tiersPlural: { exclusiva: "Sponsor Esclusiva", oficial: "Partner Ufficiale", premium: "Sponsor Premium", intermediario: "Co-sponsor", apoiante: "Sostenitori" },
        },
        quotas: {
            titulo: "QUOTE E COME DIVENTARE SOCIO",
            valor: "Quota: CHF 2 al mese (CHF 24 all'anno).",
            isencao: "I membri fondatori e i membri onorari sono esentati dalla quota, in via permanente.",
            comoPagar: "Come pagare la quota. Mentre il conto bancario dell'associazione è in fase di designazione, la quota può essere pagata in contanti, direttamente presso {famosa}. Conserva la prova di pagamento e allegalà alla domanda di adesione.",
            admissao: "Ammissione. La domanda di adesione è esaminata dal Comitato Esecutivo, che decide ai sensi dell'art. 6 dello Statuto.",
            categoriasTitulo: "Categorie di membri (art. 5 dello Statuto)",
            fundadores: "Fondatori — esentati dalla quota, in via permanente",
            efetivos: "Effettivi — persone fisiche o giuridiche ammesse dal Comitato Esecutivo",
            honorarios: "Onorari — servizi rilevanti all'associazione, esentati dalla quota",
            apoiantes: "Sostenitori — sostengono finanziariamente l'associazione; senza diritto di voto",
        },
        form: {
            titulo: "DOMANDA DI ADESIONE",
            nome: "Nome completo", rua: "Via e numero", cp: "CAP", localidade: "Località", pais: "Paese",
            email: "E-mail", telefone: "Telefono", telefoneOpc: "facoltativo",
            categoria: "Categoria desiderata", catEfetivo: "Membro effettivo", catApoiante: "Membro sostenitore",
            comprovativo: "Prova di pagamento della quota",
            comprovativoNota: "PDF, JPG o PNG · max. 10 MB",
            escolherFicheiro: "Scegli file",
            aceiteEstatutos: "Ho letto e accetto lo Statuto dell'Associazione Fados à Mesa.",
            verEstatutos: "vedi lo Statuto",
            aceiteDados: "Autorizzo il trattamento dei miei dati personali da parte dell'Associazione Fados à Mesa, esclusivamente per la gestione della mia adesione, ai sensi della Legge Federale sulla Protezione dei Dati (nLPD).",
            verNota: "vedi la nota sulla protezione dei dati",
            enviar: "Invia la domanda", aEnviar: "Invio in corso...",
            sucesso: "Domanda ricevuta. La Sua domanda di adesione sarà esaminata dal Comitato Esecutivo. Riceverà la risposta per e-mail.",
            erroObrigatorio: "Campo obbligatorio",
            erroEmail: "E-mail non valida",
            erroFicheiroTipo: "Solo PDF, JPG o PNG",
            erroFicheiroGrande: "Il file supera i 10 MB",
            erroGeral: "Non è stato possibile inviare la domanda. Riprova.",
        },
        estatutos: { titulo: "STATUTO", indice: "Indice", descarregar: "Scarica lo Statuto (PDF)" },
        cartao: {
            titulo: "CARTA DI MEMBRO",
            categoriaEfetivo: "Membro Effettivo", categoriaApoiante: "Membro Sostenitore",
            numero: "Membro N.", desde: "Membro dal", valido: "Carta valida",
            guardar: "Salva immagine", partilhar: "Condividi",
            nota: "Presenti questa carta agli eventi dell'Associazione Fados à Mesa. Salvi l'immagine sul telefono o aggiunga questa pagina alla schermata iniziale.",
            invalidoTitulo: "Carta non valida",
            invalidoTexto: "Questa carta di membro non è valida o è stata revocata. In caso di dubbio, ci contatti tramite la pagina Contatti.",
            aCarregar: "Verifica della carta…",
        },
        protecao: {
            titulo: "PROTEZIONE DEI DATI",
            texto: "L'Associazione Fados à Mesa tratta i dati personali dei suoi membri e richiedenti esclusivamente per la gestione delle adesioni e delle attività dell'associazione, in conformità con la Legge Federale sulla Protezione dei Dati (nLPD) e con l'art. 27 dello Statuto. I dati non vengono mai ceduti a terzi per fini commerciali. Per accedere, correggere o cancellare i Suoi dati, contatti produktion@fadosamesa.ch.",
        },
    },
    faq: {
        titulo: "Domande Frequenti",
        items: [
            { q: "Le bevande sono incluse nel biglietto?", a: "Il biglietto include porto d'onore, antipasti, zuppa, piatto principale, dessert e un caffè a persona. Bevande e digestivi sono a parte." },
            { q: "Devo confermare il piatto principale?", a: "Sì. Conferma la tua presenza e la scelta del piatto (pesce o carne) entro il 1º novembre 2026 su fadosamesa.ch/confirmar." },
            { q: "Dove compro i biglietti?", a: "Nella biglietteria ufficiale su fadosamesa.ch/bilhetes (Eventim Light / Ticket Corner). L'evento è esclusivo e i posti sono limitati." },
            { q: "Come arrivo al Centro Papa Giovanni?", a: "Hübelistrasse 55, 6020 Emmenbrücke — 10 minuti a piedi dalla stazione di Emmenbrücke Gersag, con parcheggio gratuito nei dintorni. Tutti i dettagli su fadosamesa.ch/local." },
        ],
    },
    experiencia: {
        tabs: { menu: "Menu della Serata", cultura: "Cultura e Tradizione", gastro: "Gastronomia e Vini", bar: "Bar" },
        bar: {
            nome: "A Famosa — Café & Sabores",
            cargoA: "Gestione e servizio a cura della",
            cargoB: "Pastelaria Famosa de Emmenbrücke",
            horarioTitulo: "Orari di Apertura",
            blocos: [
                { horas: "17H00 – 18H30", estado: "Aperto", nota: "Ricevimento e Porto de Honra (brindisi di benvenuto), fino al servizio degli antipasti della cena." },
                { horas: "18H30 – 23H30", estado: "Chiuso", nota: "Per tutta la durata dell'evento." },
                { horas: "23H30 – 01H00", estado: "Riaperto", nota: "In continuazione fino alla chiusura del locale." },
            ],
            regra: "La regola dell'esclusività e del pagamento al momento dell'acquisto restano invariati.",
        },
        tituloA: "Una notte ",
        tituloGold: "portoghese",
        tituloB: ",",
        tituloC: "servita a tavola.",
        p1: "Fados à Mesa è una cena-spettacolo che unisce il meglio di due patrimoni: la gastronomia portoghese e il Fado. Tra una portata e l'altra, la chitarra portoghese e la voce del fadista riempiono la sala, come nelle case di fado di Lisbona — ma qui, in Svizzera.",
        p2: "Un'intera serata pensata nei minimi dettagli: la tavola apparecchiata, le candele accese, il vino servito e il silenzio sacro quando inizia il fado.",
        menuLabel: "Menu ufficiale della 1ª edizione",
        menuOficial: {
            bebidasTitulo: "Le bevande sono a parte.",
            bebidasTexto: "Non sono incluse nel prezzo del biglietto.",
            entradas: "Antipasti",
            sopa: "Zuppa",
            sopaValor: "Caldo Verde",
            sopaTrad: "zuppa tradizionale portoghese di cavolo",
            prato: "Piatto Principale",
            peixeLabel: "Opzione 1 — Pesce",
            peixeValor: "Lombo de Bacalhau Assado no Forno com Batata a Murro",
            peixeTrad: "lombo di baccalà arrosto al forno con patate « a murro »",
            carneLabel: "Opzione 2 — Carne",
            carneValor: "Lombo de Porco com Batata Assada e Arroz",
            carneTrad: "lombo di maiale arrosto con patate arrosto e riso",
            acompanhamento: "Entrambi accompagnati da insalata di lattuga e pomodori.",
            sobremesa: "Dessert",
            sobremesaNota: "Una di due opzioni a scelta",
            sobremesaOpcoes: "Budino casalingo · Macedonia",
            final: "Per Finire",
            finalValor: "Caffè",
            notaBilhetes: "I biglietti acquistati nella stessa prenotazione garantiscono un posto allo stesso tavolo, quando possibile.",
            notaSilencio: "Per preservare la magia del Fado dal vivo, ti chiediamo di entrare o uscire dalla sala solo durante gli intervalli.",
            notaEstacionamento: "Parcheggio gratuito nelle vicinanze del Centro Papa Giovanni (non appartiene alla sala; soggetto a disponibilità).",
            notaRececao: "All'arrivo, segui le indicazioni del nostro team di reception.",
            fecho: "Ti aspettiamo per una serata indimenticabile, di cultura portoghese, gastronomia e la tradizione intramontabile del Fado.",
        },
        zoomHint: "Tocca il menu per ingrandire",
        importante: "Importante",
        notaA: "Ogni ospite dovrà confermare la propria presenza e la scelta del piatto principale (pesce o carne) entro il ",
        notaB: "Ogni ospite dovrà confermare la propria presenza e la scelta del piatto principale entro il ",
        prazoData: "1º novembre 2026",
        confirmar: "Confermare il piatto principale",
        culturaTitulo: "LA SERATA, MOMENTO PER MOMENTO",
        lineupTitulo: "Line Up della Serata",
        lineup: [
            { hora: "17h00", momento: "Arrivo degli ospiti (fino alle 17:30)" },
            { hora: "17h00", momento: "Bar aperto (fino alle 18:30)", link: true },
            { hora: "17h30", momento: "Porto d'Onore" },
            { hora: "18h30", momento: "Antipasti e bevande serviti al tavolo" },
            { hora: "19h00", momento: "Primo spettacolo di Fado" },
            { hora: "19h30", momento: "Zuppa" },
            { hora: "20h30", momento: "Secondo momento di Fado" },
            { hora: "21h00", momento: "Piatto principale" },
            { hora: "21h45", momento: "Terzo momento di Fado" },
            { hora: "22h30", momento: "Dessert e caffè" },
            { hora: "22h30", momento: "La cucina chiude" },
            { hora: "23h00", momento: "L'ultimo fado della serata" },
            { hora: "23h45", momento: "Chiusura della sala — solo il bar in funzione, fino all'01:00 (chiusura dello spazio)", link: true },
            { hora: "01h30", momento: "Chiusura del Centro Papa Giovanni" },
        ],
        lineupLink: "Vedi il funzionamento del bar",
        lineupNota: "Orario indicativo della 1ª edizione — soggetto a conferma.",
        etiquetaTitulo: "Quando si Canta il Fado",
        etiquetaTexto: "«Silenzio, si sta per cantare il fado.» Alla portoghese: quando la chitarra inizia, la sala ammutolisce — si ascolta con rispetto, si sente in silenzio e si applaude alla fine. È così a Lisbona, e sarà così alla nostra tavola.",
        bilheteTitulo: "Il Tuo Biglietto Include",
        incluido: [
            "Porto d'onore all'arrivo",
            "Antipasti",
            "Zuppa",
            "Piatto principale",
            "Dessert",
            "1 caffè a persona",
        ],
        bebidas: "Bevande e digestivi sono a parte.",
        exclusivo: "Evento esclusivo — posti limitati",
        gastroTitulo: "GASTRONOMIA E VINI",
        gastroCardTitulo: "Gastronomia Portoghese",
        gastroP1: "I nostri piatti nascono da prodotti di origine portoghese, scelti con il rispetto di chi cucina per la famiglia: l'olio d'oliva, il baccalà, gli insaccati e i dolci che attraversano le frontiere per arrivare sulla vostra tavola come si fa in Portogallo.",
        gastroP2: "Chi prepara ogni piatto sarà presentato a breve — la nostra cucina viene scelta con la stessa cura con cui si accorda una chitarra.",
        vinhosCardTitulo: "Vini Portoghesi",
        vinhosP1: "Una selezione di vini delle migliori regioni del Portogallo — dal Douro all'Alentejo, dal Dão ai vini verdi del Minho — pensata per accompagnare ogni momento della cena e ogni fado della serata.",
        vinhosP2: "La carta dei vini della 1ª edizione sarà rivelata a breve.",
    },
    equipa: {
        titulo: "IL NOSTRO TEAM",
        tabs: { producao: "Produzione", staff: "Staff" },
        producaoTitulo: "Team di Produzione",
        staffTitulo: "Staff — Cucina, Sala e Bar",
        cozinhaTitulo: "Cucina",
        salaTitulo: "Sala",
        barTitulo: "Bar",
        apoioTitulo: "Team di Cucina e Staff",
        producao: [
            {
                id: "paula-angelino", nome: "Paula Angelino", papel: "Direttrice Esecutiva — Artistica e Creativa",
                texto: "Responsabile della visione artistica e creativa di Fados à Mesa, guida l'identità del progetto, la comunicazione e la produzione. Il suo obiettivo è promuovere la cultura portoghese attraverso esperienze autentiche che uniscono musica, gastronomia e tradizione.",
            },
            {
                id: "paula-silva", nome: "Paula Silva", papel: "Direttrice Logistica e Staff",
                texto: "Responsabile dell'organizzazione operativa e del coordinamento dei team, assicura che ogni dettaglio sia pianificato con rigore e che ogni evento si svolga con qualità e ospitalità portoghese.",
            },
            {
                id: "paulo-nunes", nome: "Paulo Nunes", papel: "Direttore Tecnico e Responsabile della Sicurezza degli Spazi",
                texto: "Responsabile del coordinamento tecnico e della sicurezza degli spazi, garantisce che ogni evento si svolga con eccellenza, professionalità e totale affidabilità.",
            },
        ],
        cozinha: [
            {
                id: "fernando-rocha", nome: "Fernando Rocha", papel: "Capo Cuoco",
                texto: "Responsabile della creazione e dell'esecuzione dei menu, assicura la qualità, l'autenticità e la presentazione di ogni piatto, valorizzando i migliori ingredienti e la tradizione della gastronomia portoghese.",
            },
            {
                id: "cristina-moita", nome: "Cristina Moita", papel: "Sous Chef di Cucina",
                texto: "Responsabile del supporto alla gestione della cucina e del coordinamento del team, garantisce organizzazione, rigore e il buon funzionamento di tutte le aree, contribuendo a far arrivare ogni dettaglio a tavola con eccellenza.",
            },
        ],
        apoio: ["Cátia Ambrai", "Paulo", "Márcia Pinheiro"],
        sala: {
            id: "sergio-rego", nome: "Sérgio Rêgo", papel: "Capo Sala",
            texto: "Arrivato direttamente da Lisbona, lavora quotidianamente con gli artisti che presentiamo, assicurando un servizio di sala attento, discreto ed eccellente, affinché ogni serata sia un'esperienza indimenticabile.",
        },
        salaApoio: { nome: "Rui Borges", papel: "Supporto di Sala" },
        barMembro: { nome: "Rui Borges", papel: "Pastelaria Famosa de Emmenbrücke" },
    },
    missao: {
        label: "La Missione",
        tituloA: "PORTARE LA ",
        tituloGold: "CULTURA PORTOGHESE",
        tituloB: " IN SVIZZERA",
        subtitulo: "La sera in cui il Portogallo invita la Svizzera a sedersi alla nostra tavola, rendendo omaggio a un'amicizia costruita nel corso di generazioni tra il popolo portoghese e il paese che lo ha accolto.",
        capitulos: [
            {
                titulo: "L'Origine",
                paragrafos: [
                    "Fados à Mesa nasce dalla volontà di presentare il Fado nella sua forma più autentica, rispettando la tradizione di un'espressione artistica riconosciuta dall'UNESCO come Patrimonio Culturale Immateriale dell'Umanità.",
                    "Più di un genere musicale, il Fado è un modo di preservare la memoria, trasmettere emozioni e raccontare la storia di un popolo. È un patrimonio vivo che attraversa le generazioni e continua a unire le persone attraverso la poesia, la musica e l'identità culturale portoghese.",
                ],
            },
            {
                titulo: "Più di un Concerto",
                paragrafos: [
                    "Per questo una notte di Fado non si vive come un concerto convenzionale. Si vive in un'atmosfera intima, dove la vicinanza tra artisti e pubblico crea un'esperienza profondamente umana. Ogni interpretazione si ascolta con rispetto, ogni parola è valorizzata e ogni silenzio fa parte della musica.",
                ],
            },
            {
                titulo: "La Cultura Merita Tempo",
                paragrafos: [
                    "A Fados à Mesa crediamo che la cultura meriti tempo. Meriti attenzione. Meriti uno spazio in cui il patrimonio possa essere vissuto con autenticità, dignità ed eleganza.",
                    "L'evento è stato attentamente concepito per offrire un'esperienza culturale di altissima qualità, in cui la tradizione portoghese è presentata in forma contemporanea, accogliente e fedele al riconoscimento internazionale che il Fado ha conquistato.",
                ],
            },
            {
                titulo: "Il Portogallo Che Viaggia",
                paragrafos: [
                    "Quando la distanza rende difficile il ritorno in Portogallo, è il Portogallo che viaggia verso chi ne sente la saudade. Fados à Mesa nasce anche da questo proposito: ricreare, per una notte, un'atmosfera in cui la memoria, l'identità e il senso di appartenenza tornano a vivere attraverso la musica, la tradizione e la cultura portoghese.",
                ],
            },
            {
                titulo: "Un Invito alla Svizzera",
                paragrafos: [
                    "Ma questo progetto va oltre la comunità portoghese. È anche un gesto di amicizia e di condivisione. È il Portogallo che invita la Svizzera a sedersi alla nostra tavola. Un invito a scoprire una cultura riconosciuta in tutto il mondo, non solo per la bellezza della sua musica, ma anche per l'autenticità, l'ospitalità e la ricchezza del suo patrimonio.",
                    "Più di una cena-spettacolo, Fados à Mesa vuole affermarsi come uno spazio d'incontro tra culture, dove portoghesi, svizzeri e visitatori di diverse origini condividono la stessa tavola, ascoltano le stesse storie e scoprono che la cultura è un linguaggio universale capace di avvicinare le persone.",
                ],
            },
        ],
        valores: [
            { n: "I", title: "Cultura", text: "Portare il Fado — patrimonio immateriale dell'umanità — a nuovi pubblici." },
            { n: "II", title: "Tavola", text: "Condividere la gastronomia e i vini che raccontano la storia del Portogallo." },
            { n: "III", title: "Incontro", text: "Creare in Svizzera un punto d'incontro tra culture, attorno alla tavola." },
        ],
        fechoA: "In un'epoca in cui tante esperienze si vivono di fretta, il Fado ci invita a fare esattamente il contrario: fermarci, ascoltare e sentire.",
        fechoB: "Perché ci sono momenti in cui il più grande segno di rispetto non è l'applauso. È il silenzio.",
        fechoFinal: "Silenzio... si sta per cantare il Fado.",
    },
    contacto: {
        titulo: "CONTATTACI",
        intro: "Per qualsiasi cosa riguardi Fados à Mesa, scrivici qui — risponderemo con piacere.",
        nome: "Nome",
        nomePh: "Il tuo nome",
        email: "Email",
        emailPh: "latuaemail@esempio.com",
        assunto: "Oggetto",
        assuntos: [
            "Prenotazioni di gruppo",
            "Partnership e sponsorizzazioni",
            "Stampa e media",
            "Domande sulla 1ª edizione",
            "Altro argomento",
        ],
        mensagem: "Messaggio",
        mensagemPh: "Scrivi il tuo messaggio...",
        enviar: "Invia Messaggio",
        aEnviar: "Invio in corso...",
        erroGenerico: "Non è stato possibile inviare il messaggio. Riprova, per favore.",
        sucessoTitulo: "Messaggio inviato.",
        sucessoTexto: "Grazie, {nome}. Abbiamo ricevuto il tuo messaggio e risponderemo presto.",
        fecho: "Una notte Portoghese, con assoluta certezza.",
    },
    local: {
        label: "Dove si svolge l'evento",
        titulo: "COME ARRIVARE",
        intro: "Tutte le informazioni pratiche sul luogo e sui modi per arrivare a Emmenbrücke — mezzi pubblici, auto, Uber/taxi o bicicletta.",
        morada: "Hübelistrasse 55, 6020 Emmenbrücke, Svizzera — 47.0706° N, 8.2849° E",
        moradaCurta: "Hübelistrasse 55, 6020 Emmenbrücke",
        comoChegar: "COME ARRIVARE",
        cards: [
            {
                id: "transportes",
                title: "Con i Trasporti Pubblici",
                text: "La stazione di Emmenbrücke Gersag si trova a circa 10 minuti a piedi ed è servita da treni regionali e dagli autobus 41, 42, 43 e 44. Da Lucerna, la linea 2 della VBL collega al centro di Emmenbrücke; al ritorno, l'autobus notturno N2 collega Lucerna.",
            },
            {
                id: "carro",
                title: "In Auto",
                text: "A 5 minuti dall'autostrada A2 (uscita Emmen Nord). Parcheggio Häger gratuito proprio di fronte, limitato ai posti segnalati «Häger» — tutti i dettagli qui sotto.",
            },
            {
                id: "uber",
                title: "Con Uber o Taxi",
                text: "Uber opera a Lucerna e dintorni: una corsa dal centro di Lucerna dura circa 10 minuti.",
            },
            {
                id: "bicicleta",
                title: "In Bicicletta",
                text: "Emmen è a pochi minuti di bicicletta da Lucerna, lungo piste ciclabili. Il parcheggio per biciclette è disponibile in loco.",
            },
        ],
        mapsCta: "Apri in Google Maps",
        mapsTexto: "Inquadra il codice con la fotocamera o tocca qui — la posizione esatta e i parcheggi più vicini sono a un tocco di distanza.",
        barTitulo: "Bar nel Locale",
        barTexto: "Aperto 17:00–18:30 e 23:30–01:00. Gestito dalla Pastelaria Famosa de Emmenbrücke — pagamento al momento dell'acquisto.",
        estacionamentoHager: {
            titulo: "Parcheggio Gratuito — Häger",
            intro: "Il parcheggio più vicino all'evento è quello di Häger, proprio di fronte al Centro Papa Giovanni — gratuito, ma limitato alla capacità del posto.",
            pontos: [
                "Solo i posti segnalati «Häger» sono messi a disposizione dei clienti dell'evento.",
                "Questa informazione ha carattere puramente informativo: non ci assumiamo alcuna responsabilità per l'occupazione del parcheggio. Non è necessario pagare il parcheggio.",
                "Se il parcheggio è pieno, cercate nelle immediate vicinanze — ci sono diversi altri parcheggi disponibili, alcuni gratuiti e altri a pagamento.",
            ],
            mapsCta: "Vedi il parcheggio su Google Maps",
        },
        fecho: "Arrivare è facile. Il difficile sarà andarsene.",
    },
    noticias: {
        label: "Sala stampa",
        titulo: "NOTIZIE",
        intro: "Benvenuti nella pagina ufficiale delle notizie di Fados à Mesa. Qui troverete gli ultimi annunci ufficiali di Fados à Mesa, insieme a notizie accuratamente selezionate sugli artisti che partecipano al nostro evento. Il nostro obiettivo è tenervi informati attraverso fonti affidabili e ufficiali, valorizzando gli artisti che rendono possibile questo progetto. Questa pagina viene aggiornata regolarmente ogni volta che sono disponibili nuove informazioni ufficiali.",
        socialTitulo: "IL NOSTRO ULTIMO POST",
        socialTituloMulti: "I NOSTRI ULTIMI POST",
        socialVer: "Vedi il post",
        socialSeguir: "Seguici",
        socialBio: "Fados à Mesa è arrivato su Instagram — seguiteci per gli annunci ufficiali, gli artisti e il dietro le quinte della serata.",
        verTodas: "Vedi tutte le notizie",
        ultimasTitulo: "ULTIME NOTIZIE",
        filtros: { todas: "Tutti", projeto: "Fados à Mesa" },
        pesquisaPh: "Cerca notizie per parola chiave...",
        lerMais: "Leggi di più",
        carregarMais: "Carica altro",
        aCarregar: "Caricamento...",
        semResultados: "Nessuna notizia trovata. Prova un altro artista o un'altra parola chiave.",
        fonte: "Fonte",
        ctaTitulo: "Vivi il Fado dal Vivo",
        ctaReservar: "Prenota il Tuo Posto",
    },
    patrocinadoresPage: {
        titulo: "SPONSOR UFFICIALI",
        texto: "I partner che rendono possibile questa serata — grazie per credere nella cultura portoghese in Svizzera.",
    },
    confirmacao: {
        label: "1ª Edizione · 14 Novembre 2026",
        titulo: "CONFERMA LA TUA PRESENZA",
        introA: "Conferma la tua presenza e scegli il piatto principale entro il ",
        prazoData: "1º novembre 2026",
        nome: "Nome completo",
        nomePh: "Il tuo nome",
        email: "Email",
        emailPh: "latuaemail@esempio.com",
        bilhete: "Numero del biglietto (Ticket Corner)",
        bilhetePh: "Es.: TC-123456789",
        escolhePrato: "Scegli il piatto principale",
        opcoes: [
            { id: "peixe", title: "Opzione 1 — Pesce", desc: "Trancio di baccalà arrosto con patate a murro e insalata" },
            { id: "carne", title: "Opzione 2 — Carne", desc: "Lonza di maiale arrosto con patate a murro e insalata" },
        ],
        submit: "Conferma Presenza",
        aRegistar: "Registrazione in corso...",
        erroGenerico: "Non è stato possibile registrare la conferma. Riprova, per favore.",
        sucessoTitulo: "Presenza confermata.",
        sucessoTexto: "Grazie, {nome}. La tua scelta ({prato}) è stata registrata. A presto — il 14 novembre, a tavola.",
        peixe: "pesce",
        carne: "carne",
    },
    vantagens: {
        label: "Soci",
        titulo: "VANTAGGI E CONVENZIONI PER I SOCI",
        intro: "Essere socio di Fados à Mesa costa CHF 2 al mese (CHF 24 all'anno) e dà accesso a sconti in diversi luoghi, in Portogallo e in Svizzera — già dalla 1ª edizione.",
        prova: "Per usufruire delle convenzioni basta mostrare la Tessera Socio Digitale (con QR code) o indicare il proprio numero di socio.",
        bilhetesTitulo: "Biglietti della 1ª Edizione — 14 novembre 2026",
        bilhetesIntro: "Sconto immediato sull'acquisto di biglietti fisici presso la Pastelaria Famosa, Emmenbrücke (contanti, Twint o bonifico).",
        colBilhete: "Biglietto",
        colAte: "Fino al 31.10.2026",
        colDepois: "Dal 01.11.2026",
        linhas: [
            ["Adulto, prezzo normale", "CHF 119.90", "CHF 129.90"],
            ["Socio, 1º biglietto adulto (− CHF 20)", "CHF 99.90", "CHF 109.90"],
            ["Adulto acquistato insieme a un socio (− CHF 10)", "CHF 109.90", "CHF 119.90"],
            ["Bambino (6–15 anni)", "CHF 65.00", "CHF 65.00"],
            ["Bambino acquistato insieme a un socio (− CHF 5)", "CHF 60.00", "CHF 60.00"],
        ],
        bilhetesNota: "Gli sconti soci si applicano solo ai biglietti acquistati insieme al socio, nella stessa transazione. Il numero di socio deve essere indicato su tutti i biglietti, per la registrazione interna.",
        fisicoTitulo: "Perché solo biglietti fisici?",
        fisicoTexto: "Per motivi di gestione del progetto, in questa 1ª edizione i biglietti con sconto socio sono disponibili solo fisicamente, presso la Pastelaria Famosa. Intendiamo risolvere questa situazione in una prossima edizione ed estendere lo sconto anche all'acquisto online.",
        protocolosTitulo: "Convenzioni con i Partner",
        srVinhoTitulo: "Sr. Vinho — Ristorante Tipico",
        srVinhoTag: "Partner Ufficiale",
        srVinhoTexto: "Tutti i soci di Fados à Mesa hanno, da subito, il 10% di sconto sul pagamento in contanti dell'importo finale della cena al ristorante Sr. Vinho, e un digestivo in omaggio.",
        srVinhoCta: "Vedi il menu del Sr. Vinho",
        famosaTitulo: "Pastelaria Famosa — Emmenbrücke",
        famosaTag: "Sponsor Esclusiva",
        famosaTexto: "Punto vendita ufficiale dei biglietti fisici con sconto socio per la 1ª edizione. Pagamento in contanti, Twint o bonifico bancario.",
        cr7Titulo: "CR7 Helder — Trasporto in Limousine",
        cr7Tag: "Sponsor Premium Ufficiale",
        cr7Texto: "Con il codice CR7, i soci hanno il 10% di sconto su tutte le limousine Vachoux (Helder Pacheco). Offerta limitata al territorio della Città di Ginevra, per percorsi di 45 minuti, con limousine da 12 a 16 persone al massimo.",
        cr7Codigo: "Codice: CR7",
        cr7Cta: "Prenota su vachoux.com",
        emBreve: "Altre convenzioni in arrivo in Portogallo e in Svizzera. I soci saranno informati via e-mail.",
        ctaTitulo: "Non sei ancora socio?",
        ctaTexto: "Adesione semplice, online, per CHF 24/anno.",
        cta: "Diventare socio",
    },
    bilhetes: {
        precosTitulo: "Prezzi dei Biglietti",
        precosStandard: "Standard",
        precosEarlyBird: "Early Bird",
        precosNormal: "Prezzo Intero",
        precosCrianca: "Bambino (6–15 anni)",
        precosCriancaNota: "Cena con acqua e un succo della casa in omaggio · Porto de Honra non incluso",
        socioLink: "Soci: CHF 20 di sconto sul 1º biglietto — vedi i vantaggi",
        precosNota: "Bevande non incluse · Posti limitati · Dress code: abbigliamento elegante da cena (non è un gala, ma quasi)",
        titulo: "BIGLIETTERIA",
        data: "14 Novembre 2026 · Centro Papa Giovanni, Emmenbrücke",
        exclusivo: "Evento esclusivo · Posti limitati",
        confirmarReserva: "Conferma la Prenotazione",
        nota: "Biglietteria ufficiale Eventim. Dopo l'acquisto, conferma la tua presenza e la scelta del piatto su ",
    },
    ticketcorner: { label: "PARTNER UFFICIALE DI VENDITA" },
    privacidade: {
        label: "Fados à Mesa",
        titulo: "INFORMATIVA SULLA PRIVACY",
        seccoes: [
            {
                title: "1. Titolare del trattamento dei dati",
                text: "Il titolare del trattamento dei dati personali su questo sito è l'Associazione Fados à Mesa (di seguito «noi»), UID CHE-306.330.271, Gerliswilstrasse 46, 6020 Emmenbrücke, Svizzera. Per qualsiasi domanda relativa alla protezione dei dati, contattaci tramite la pagina Contatti.",
            },
            {
                title: "2. Quadro giuridico",
                text: "Il trattamento dei dati personali avviene in conformità con la Legge federale svizzera sulla protezione dei dati (nLPD, in vigore dal 1º settembre 2023) e con la restante legislazione svizzera applicabile.",
            },
            {
                title: "3. Dati che raccogliamo",
                text: "In questa fase, il sito non raccoglie dati personali tramite moduli. Quando ci contatti via email, trattiamo il tuo indirizzo e il contenuto del messaggio solo per rispondere alla tua richiesta. I dati di prenotazione o di acquisto dei biglietti saranno trattati in futuro tramite la piattaforma Ticket Corner, secondo l'informativa sulla privacy di tale piattaforma.",
            },
            {
                title: "4. Cookie e strumenti di analisi",
                text: "Questo sito non utilizza attualmente cookie di tracciamento né strumenti di analisi di terze parti. Qualora venissero introdotti, questa informativa sarà aggiornata di conseguenza.",
            },
            {
                title: "5. I tuoi diritti",
                text: "Ai sensi della legislazione svizzera, hai il diritto di richiedere informazioni sui tuoi dati personali, nonché la loro rettifica o cancellazione. Per esercitare questi diritti, contattaci tramite la pagina Contatti.",
            },
            {
                title: "6. Modifiche",
                text: "Ci riserviamo il diritto di aggiornare questa informativa in qualsiasi momento. La versione in vigore è quella pubblicata su questa pagina. Ultimo aggiornamento: settembre 2026.",
            },
        ],
    },
    termos: {
        label: "Fados à Mesa",
        titulo: "TERMINI E CONDIZIONI",
        seccoes: [
            {
                title: "1. Oggetto",
                text: "I presenti Termini e Condizioni regolano l'utilizzo del sito Fados à Mesa e la partecipazione all'evento. Utilizzando questo sito, accetti integralmente queste condizioni.",
            },
            {
                title: "2. Proprietà intellettuale",
                text: "Il concetto, la denominazione «Fados à Mesa», il logo, i testi, le fotografie, i video, il design e tutti i contenuti di questo sito sono proprietà esclusiva dell'organizzazione dell'evento e sono protetti dalla Legge federale svizzera sul diritto d'autore e sui diritti connessi (LDA/URG) e dalle convenzioni internazionali applicabili. È espressamente vietata la riproduzione, copia, imitazione, distribuzione o utilizzazione, totale o parziale, del concetto, del marchio, dei testi, delle immagini o di qualsiasi elemento distintivo del progetto, senza autorizzazione preventiva e scritta dell'organizzazione. Ogni violazione sarà oggetto di azione legale secondo la legislazione svizzera.",
            },
            {
                title: "3. Biglietti e prenotazioni",
                text: "La vendita dei biglietti sarà effettuata tramite la piattaforma Ticket Corner, applicandosi i termini e le condizioni di tale piattaforma. L'evento ha capienza limitata; la prenotazione è valida solo dopo la conferma del pagamento.",
            },
            {
                title: "4. Programma e modifiche",
                text: "L'organizzazione si riserva il diritto di adeguare il programma, gli orari, il menu e il cast per motivi di forza maggiore, garantendo sempre la qualità dell'esperienza annunciata.",
            },
            {
                title: "5. Responsabilità",
                text: "L'organizzazione non è responsabile per danni derivanti da informazioni di terzi, guasti tecnici estranei o uso improprio del sito. Il consumo di bevande alcoliche è riservato ai maggiorenni, secondo la legislazione svizzera.",
            },
            {
                title: "6. Legge applicabile e foro",
                text: "I presenti Termini sono regolati dal diritto svizzero. Per qualsiasi controversia è competente il foro del domicilio dell'organizzazione, in Svizzera. Ultimo aggiornamento: settembre 2026.",
            },
        ],
    },
    artistPage: {
        naoEncontrado: "Artista non trovato.",
        imprensa: "Stampa & Riconoscimenti",
        emPalco: "Sul palco",
        oQueA: "Cosa ti ",
        oQueGold: "aspetta",
        oQueB: "",
    },
    artists: {
        "rafael-pacheco": {
            role: "Chitarra Portoghese",
            bio: "Nato a Portimão (2000), ha iniziato a 11 anni nella scuola di fado Boa Esperança e si è formato con il prestigioso chitarrista di chitarra portoghese Antunes, il Principe.\n\nVincitore del Premio Nuovi Talenti Ageas, alla Casa da Música (2023), è musicista residente in emblematiche case di fado, da Viseu a Lisbona.",
        },
        "ginestal-martins": {
            role: "Viola de Fado",
            bio: "Violista di fado del circuito lisboneta, è la base musicale di innumerevoli serate — la viola che sostiene, con sensibilità, ogni voce.\n\nAccompagna i fadisti nelle case di fado e nelle Visitas Cantadas dell'EGEAC, per i quartieri storici di Lisbona, al fianco di chitarristi come Rafael Pacheco. Si esibisce anche come fadista.",
        },
        "catia-garcia": {
            role: "Fadista",
            bio: "Fadista d'anima e tradizione, porta sul palco l'emozione di chi vive il fado dall'interno. Nel 2021 ha pubblicato l'album «À Procura do Fado».\n\nPresenza regolare in televisione (RTP) e nelle serate di fado di Lisbona, compresa l'emblematica casa Sr. Vinho.",
        },
        "daniel-pinto-coelho": {
            role: "Fadista",
            bio: "Nato a Valongo, è salito sul palco per la prima volta a 4 anni e ha studiato alla London Music School, prima di arrendersi al fado nel 2014.\n\nFa parte del cast dell'emblematica casa di fado Sr. Vinho, a Lisbona, dove la sua voce elegante è una presenza abituale.",
        },
        "madalena-gil": {
            role: "Fadista",
            bio: "Nata ad Almeirim, ha incantato il paese a The Voice Kids Portugal, nel 2021, con il fado «Ser Fadista».\n\nUna voce giovane con un'anima antica, che promette di portare il fado — e il nome del Portogallo — ancora più lontano.",
        },
    },
};
